/**
 * @generated SignedSource<<9c1f67f8755065bdac45ff2f02540da2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type benefitRefundPartnerQuery$variables = {
  utmCampaign: string;
};
export type benefitRefundPartnerQuery$data = {
  readonly refundPartner: {
    readonly defaultFeeRate: string;
    readonly discountRate: string;
    readonly feeRate: string;
    readonly partnerId: string;
    readonly partnerName: string;
  } | null | undefined;
};
export type benefitRefundPartnerQuery = {
  response: benefitRefundPartnerQuery$data;
  variables: benefitRefundPartnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "utmCampaign"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "partnerId",
        "variableName": "utmCampaign"
      }
    ],
    "concreteType": "RefundPartnerOutput",
    "kind": "LinkedField",
    "name": "refundPartner",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "partnerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "partnerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feeRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultFeeRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountRate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "benefitRefundPartnerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "benefitRefundPartnerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25356a7538594324db2ee4a1033aff60",
    "id": null,
    "metadata": {},
    "name": "benefitRefundPartnerQuery",
    "operationKind": "query",
    "text": "query benefitRefundPartnerQuery(\n  $utmCampaign: String!\n) {\n  refundPartner(partnerId: $utmCampaign) {\n    partnerName\n    partnerId\n    feeRate\n    defaultFeeRate\n    discountRate\n  }\n}\n"
  }
};
})();

(node as any).hash = "1cb499a6e59bace7b39ea565578bf77e";

export default node;
